import type { AppScope } from './appScope.types';

export function workspaceIdFromSettingsPath(
  pathname: string
): string | undefined {
  const match = pathname.match(/\/settings\/w\/([^/]+)/);
  return match?.[1];
}

export function teamIdFromSettingsPath(pathname: string): string | undefined {
  const match = pathname.match(/\/settings\/w\/[^/]+\/teams\/([^/]+)/);
  return match?.[1];
}

export function resolveSettingsAppScopeFromPathname(
  pathname: string,
  organizationId: string
): AppScope | null {
  const workspaceId = workspaceIdFromSettingsPath(pathname);
  if (!workspaceId) {
    return null;
  }

  const teamId = teamIdFromSettingsPath(pathname);
  if (teamId) {
    return { level: 'team', organizationId, workspaceId, teamId };
  }

  return { level: 'workspace', organizationId, workspaceId };
}
